<template>
  <div class="home">
    <typeNav></typeNav>
    <Banner></Banner>
    <Notice></Notice>
    <Login></Login>
    <EducationList></EducationList>
    <webFooter></webFooter>
  </div>
</template>
<script>

import Banner from "@/views/home/Banner";
import Notice from "@/views/home/Notice";
import Login from "@/views/home/Login";
import EducationList from "@/views/home/EducationList";

export default {
  data() {
    return {
      
    };
  },
  components: {
    Banner,
    Notice,
    Login,
    EducationList
  },
  mounted(){
    
  }
};
</script>
<style scoped>
</style>